/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Page } from '../models/Page';
import type { Website } from '../models/Website';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PageService {
    /**
     * Get a list of websites
     * @param workspaceId Workspace ID required
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns Website Successfully retrieved websitees
     * @throws ApiError
     */
    public static getPageWebsiteList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<Website> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/page/website/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a list of all pages of a website
     * @param workspaceId Workspace ID required
     * @param websiteId Website ID of the pages fetch
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns Page Successfully retrieved pages
     * @throws ApiError
     */
    public static getPageList(
        workspaceId: string,
        websiteId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<Page> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/page/list',
            query: {
                'workspace_id': workspaceId,
                'website_id': websiteId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Search list of pages
     * @param workspaceId Workspace ID required
     * @param search Search string
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns Page Successfully retrieved pages
     * @throws ApiError
     */
    public static getPageSearch(
        workspaceId: string,
        search: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<Page> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/page/search',
            query: {
                'workspace_id': workspaceId,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get page by id
     * @param workspaceId The workspace_id of form to get or delete
     * @param id The id of page
     * @returns Page Successfully retrieved pages
     * @throws ApiError
     */
    public static getPage(
        workspaceId: string,
        id: string,
    ): CancelablePromise<Page> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/page/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
